import { put, all, takeLatest, select } from 'redux-saga/effects';

import { OBTER_TELAS_DISPONIVEIS_REQUEST } from './constants';
import { obterTelasDisponiveisSuccess } from './actions';
import { PersonalizacaoService } from '../../../common/services/personalizacao';

function* obterTelasDisponiveis() {
  const service = new PersonalizacaoService();
  const { plano, listaPlanos } = yield select((state) => state.user);

  const { sitpart, tipoBeneficio } = listaPlanos.find(
    (plan) => Number(plan.value) === Number(plano)
  );

  const telas = yield service.getTelasPorPerfil(plano, sitpart, tipoBeneficio);

  yield put(obterTelasDisponiveisSuccess(telas));
}

export default all([
  takeLatest(OBTER_TELAS_DISPONIVEIS_REQUEST, obterTelasDisponiveis),
]);
